//========gGoKwik-Cart-Slide-all-css=====//
(function() {
    function injectCSS() {
        const shadowContainer = document.querySelector("shadow-dom-container");
        if (!shadowContainer || !shadowContainer.shadowRoot) {
            setTimeout(injectCSS, 50);
            return;
        }
        
        const shadowRoot = shadowContainer.shadowRoot;
        if (shadowRoot.querySelector("#sidecart-css")) return;
        
        const style = document.createElement("style");
        style.id = "sidecart-css";
        style.textContent = `


.sidecart.svelte-1nlkjzs.svelte-1nlkjzs {
    width: 446px !important;
}
            .sidecart .side-cart-header { order: 1; }
            .sidecart .countdown-container { order: 2; }
            .sidecart .promotion-banner {  }
           .sidecart  .custom-brand-banner {order: 4;
}

            .sidecart .progress-container { order: 3; }
            .sidecart .top-section { order: 5; }
            .sidecart .sidecart-footer-wrapper { order: 6; }
            .sidecart { border-radius: 0 !important; }
            .sidecart {background: #ffffff !important;}
            .next-milestone-text.svelte-nuzrbq {
                 position: relative;
             }
             .side-cart-header.svelte-1cpywgq p.svelte-1cpywgq {
           font-weight: 400 !important;
            font-family: "PT Serif", serif !important;
               }
               .progress-container.svelte-nuzrbq .next-milestone-text.svelte-nuzrbq {
                margin-left: 45px !important;
                font-size: 16px !important;
                font-weight: 700 !important;
                    min-height: 28px !important;
                display: grid !important;
                align-items: center !important;
                    margin-bottom: 0 !important;
            }
.next-milestone-text.svelte-nuzrbq:before {
    content: '' !important;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Frame_120.svg?v=1776493675);
    width: 28px;
    height: 28px;
    position: absolute;
    left: -36px;
}
.sidecart .custom-brand-banner {
    background: #446F35 !important;
    border-radius: 0 0 15px 15px;
}
.item-list-wrapper.svelte-1k1ehgb {
    margin: 16px !important;
    margin-bottom: 0 !important;
}
.item-list-wrapper.svelte-1k1ehgb {
    border: 0 !important;
}
.product-tile-wrapper.svelte-1s3ixll.svelte-1s3ixll:not(.sku-enabled) {
    border: none !important;
    border-radius: 10px !important;
    margin-bottom: 16px !important;
    box-shadow: 0px 0px 4px 0px #00000040;
}
.progress-container.svelte-nuzrbq .container.svelte-nuzrbq {
    margin-top: 10px !important;
}
.custom-brand-banner img {
    width: 20px !important;
        height: auto !important;
}
.sidecart .custom-brand-banner {
    display: flex !important;
    justify-content: center;
    align-items: center !important;
}
.my-checkout-text {
    text-align: center;
    position: relative;
    color: #fff;
    background: #870A0A !important;
    padding: 8.5px !important;
    margin: auto;
    width: calc(100% - 40px);

}
.my-checkout-text:before {
    content: '';
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Group_17880.svg?v=1776500540);
    position: absolute;
    height: 40px;
    width: 10px;
    left: -5px;
    top: 0;
}
.my-checkout-text:after {
    content: '';
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Group_17880.svg?v=1776500540);
    position: absolute;
    height: 40px;
    width: 10px;
    right: -5px;
    top: 0;
}
.my-checkout-text span {
    position: relative;
    top: 1px;
}
.my-offer-text span {
    font-weight: 400 !important;
    font-family: "PT Serif", serif !important;
    font-size: 18px;
    color: #000 !important;
}

.my-offer-text {
    margin: 0 !important;
   padding: 14px 16px 8px !important;
}
.order-breakdown.svelte-yb4nuo {
    position: absolute !important;
    bottom: 0 !important;
}
.order-breakdown.svelte-yb4nuo {
    position: absolute !important;
    width: calc(100% - 20px);
    left: 10px;
    border: none !important;
    right: 0;
    box-shadow: 0px 0px 4px 0px #00000040;
    bottom: 118px !important;
        background: #fff !important;
}
svg.iconify.iconify--tabler {
    display: none !important;
}
body .double-button.svelte-yb4nuo .gokwik-button-wrapper .total-amount.svelte-yb4nuo {
    flex-direction: column !important;
    max-width: 50% !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout.svelte-yb4nuo {
    width:55% !important;
}

.double-button.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    flex-direction: row !important;
}

.estimated-total-container.svelte-yb4nuo * {
    text-align: left !important;
}

.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .estimated-total-container.svelte-yb4nuo {
    margin-right: auto !important;
}
.double-button.svelte-yb4nuo .gokwik-button-wrapper .total-amount.svelte-yb4nuo {
    flex-direction: column !important;
    align-items: center !important;
    max-width: 45% !important;
}
.side-cart-header.svelte-1cpywgq.svelte-1cpywgq {
    padding: 10px 16px !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total.svelte-yb4nuo {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #9B5E34 !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo svg {
    min-width: 15px  !important;
    width: 15px  !important;
    height: 15px  !important;
    padding: 0 !important;
    flex-shrink: 0  !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo {
    gap: 0  !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper .total-amount .estimated-total-section.svelte-yb4nuo svg path{
       fill: #9B5E34 !important;
}
.item.svelte-1s3ixll .item-price .compare-at-price.svelte-1s3ixll {
    font-size: 11px !important;
    color: #999999 !important;
}
.item.svelte-1s3ixll .item-price .discount-percentage.svelte-1s3ixll {
    color: #FE7E42 !important;
    font-weight: 700 !important;
    font-size: 12px !important;
}
.item.svelte-1s3ixll .item-price .final-price.svelte-1s3ixll,  .item-price span.svelte-1s3ixll {
    font-weight: 700 !important;
    font-size: 16px !important;
}
  .item.svelte-1s3ixll .details .sidecart-product-title.svelte-1s3ixll {
    font-size: 16px !important;
    font-weight: 700 !important;
}
.sidecart-footer.svelte-yb4nuo.svelte-yb4nuo {
    padding: 5px 16px !important;
} 
.ribbon.svelte-1wgo1p4 {
    background: #446F35 !important;
}
.ribbon.svelte-1wgo1p4::after {
    border-left: 5px solid #3d7139 !important;
}
.ribbon.svelte-1wgo1p4:before, .ribbon.svelte-1wgo1p4:after, .ribbon.svelte-1wgo1p4::before {
    background: #3d7139 !important;
}
.ribbon.svelte-1wgo1p4::before {
    border-right: 5px solid #3d7139 !important;
}
.offer-box.svelte-1uev9t0.svelte-1uev9t0 {
    padding-top: 16px !important;
    background: #F5F5F5 !important;
    gap: 20px !important;
}
.discount-input-area.svelte-hjytin input.svelte-hjytin {
    background: #f5f5f5 !important;
    width: 100% !important;

}
.view-offers-button.svelte-1uev9t0.svelte-1uev9t0 {
    background-color: #f5f5f5 !important;
    width: auto !important;
    padding: 0 !important;
}
    .view-notes-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
        margin: 0;
}
    svg.arrow-icon.iconify.iconify--mingcute path+path {
    fill: #9b5e34 !important;
}
    .offer-box.svelte-1uev9t0 span.svelte-1uev9t0:first-child {
    margin-right: 0 !important;
}
        .view-offers-button.svelte-1uev9t0 .offers-text.svelte-1uev9t0 {
    color: #9b5e34 !important;
}
.gokwik-checkout.svelte-yb4nuo button.svelte-yb4nuo {
    background: #9B5E34 !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout button .btn-content .btn-text.svelte-yb4nuo {
       display: block !important;
    position: relative;
    top: 2px;
}
.sidecart-footer.svelte-yb4nuo .gokwik-checkout button .btn-content .btn-text.svelte-yb4nuo * {
   font-size:16px !important;
}
span.payment-icons.svelte-yb4nuo img {
    max-height: 24px !important;
}
.double-button.svelte-yb4nuo .gokwik-button-wrapper .gokwik-checkout button.svelte-yb4nuo {
    padding: 6px !important;
    height: 48px;
    padding-left: 15px !important;
    padding-right: 15px !important;
    border-radius: 35px;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    align-items:center !important;
}
.sidecart-footer.svelte-yb4nuo .gokwik-button-wrapper.svelte-yb4nuo {
    padding: 10px 0  !important;
    align-items:center  !important;
}
.progress-container.svelte-nuzrbq .container .milestone-wrap .milestones .progress-bar-rail.svelte-nuzrbq {
    height: 4px !important;
}
.progress-container.svelte-nuzrbq .container .milestone-wrap .milestones .progress-bar-rail.svelte-nuzrbq {
    top: 31px !important;
}
span.svelte-yb4nuo {
    font-weight: 700 !important;
}
.sidecart .custom-brand-banner {
    font-size: 13px !important;
}
.item.svelte-1s3ixll.svelte-1s3ixll {
    padding: 12px 8px !important;
}
.icon-wrap.svelte-nuzrbq {
    background:transparent !important;
}
 .milestones.svelte-nuzrbq:before {
    top: 11px;
    content: ' ' !important;
    position: absolute;
    width: 26px;
    background-size: cover;
    height: 24px;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/vecteezy_ai-generated-red-gift-box-with-golden-bow-on-transparent_37796385_2.png?v=1776423763);
    z-index: 99999;
}
.view-notes-wrapper {
    display: flex;
}
.order-note.svelte-1a1nfg5 {
    box-shadow: 0px 0px 4px 0px #00000040 !important;
    background: #fff !important;
    border-radius: 20px !important;
    text-decoration: none !important;
    padding: 5px 12px 5px 25px;
    margin: 0 !important;
    position: relative;
}

.order-note p {
    font-weight: 600 !important;
    font-size: 12px !important;
    color:#000000;
    position: relative;
}
.order-note.svelte-1a1nfg5:before {
    content: '';
    height: 16px;
    position: absolute;
    width: 16px;
    background-image: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Frame.svg?v=1776681731);
    left: 6px;
}
    .upSell-container.svelte-bmzzto.mb-15 {
    border: none !important;
        padding: 0 !important;
}
.title.svelte-bmzzto {
    font-family: "PT Serif", serif !important;
    font-weight: 400 !important;
    font-size: 18px !important;;
    color: #000 !important;
}  
    .card.svelte-176ttbg {
    flex-direction: column;
}

.card.svelte-176ttbg {
    max-width: 185px !important;
    border: none !important;
    padding: 0 !important;
    flex-direction: column !important;
}
 .product-image.svelte-176ttbg.svelte-176ttbg {
    height: auto !important;
    width: 100% !important;
    border-radius: 5px !important;
    max-height: max-content !important;
}   
 p.product-name.svelte-176ttbg {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 100% !important;
        color: #000000 !important;
}   
.product-name.svelte-176ttbg.svelte-176ttbg {
    max-width: unset !important;
}
.card-right-container.svelte-176ttbg.svelte-176ttbg {
    margin-left: 0 !important;
    margin-top: 16px !important;
    gap: 2px !important;
    margin-bottom: 6px;
}
button.add-btn.svelte-176ttbg {
    color: #fff;
    font-weight: 600;
    border: none !important;
    background: #9B5E34 !important;
    border-radius: 20px !important;
    padding: 4px 13px 9px;
    text-transform: uppercase;
}
p.price.svelte-176ttbg {
    width: calc(100% - 74px);
    max-width: none !important;
    flex-direction: row-reverse;
    display: flex !important;
    align-items: center;
    gap: 2px;
}
strike.svelte-176ttbg {
    color: #3D3D3D !important;
    font-size: 10px !important;
}   
 p.price.svelte-176ttbg span {
    font-weight: 800 !important;
    font-size: 16px !important;
     color: #000000 !important;
}     
 .scroll-container.svelte-bmzzto {
    scrollbar-width: thin !important;
} 
    .discount-banner.svelte-176ttbg {
    display: none !important;
}  
 .custom-price-text h3 {
    font-family: "PT Serif", serif !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    color: #000 !important;
}   
    strike.svelte-176ttbg {
    position: relative;
    top: 1px;
} 
.item.svelte-1s3ixll .quantity-handler-wrapper.svelte-1s3ixll {
       margin-left: 0 !important;
    margin-bottom: 0 !important;
}    
span.final-price.svelte-1s3ixll {
    order: 1!important;
}    
span.discount-percentage.svelte-1s3ixll {
    order: 3 !important;
}    
 .item.svelte-1s3ixll .variant-list.svelte-1s3ixll {
    margin-top: -4px !important;
    order: 4 !important;
}   
 .variant-list.svelte-1s3ixll {
    order: 5 !important;
} 
    select.svelte-1s3ixll {
    background: #F1F0F0 !important;
    border: 0 !important;
}  
.item.svelte-1s3ixll .quantity-handler.svelte-1s3ixll {
    background: #fff !important;
    border: 1px solid #B6B6B6 !important;
    border-radius: 10px !important;
    padding: 0px 7px !important;
}
.item.svelte-1s3ixll .quantity-handler span.svelte-1s3ixll, .item.svelte-1s3ixll .quantity-handler input.item-quantity.svelte-1s3ixll {
    border-right: none !important;
    border-left:none !important;
    padding: 0 !important;
     color: #9B5E34 !important;
}  
 .item.svelte-1s3ixll .quantity-handler input.item-quantity.svelte-1s3ixll {
    font-weight: 700 !important;
    font-size: 14px !important;
}   
 .item.svelte-1s3ixll .quantity-handler.svelte-1s3ixll {
    font-size: 17px !important;

}   
.product-tile-wrapper span.review-icon {
    line-height: 0 !important;
    border-left: 1px solid #85858566 !important;
    padding-left: 5px !important;
}  
 select.svelte-1s3ixll {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important ;

} 
      span.variant-selector.svelte-1s3ixll{
            position: relative  !important;
      }
span.variant-selector.svelte-1s3ixll::after {
    content: "";
    position: absolute;
    right: 3px;
    top: 59%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: url(https://cdn.shopify.com/s/files/1/0034/7901/1441/files/expand_more.svg?v=1776753969) no-repeat center;
    background-size: contain;
    pointer-events: none;
}  
.side-cart-content-wrapper .variant-selector.svelte-1s3ixll select {
        padding: 3.5px 5px !important;
    padding-right: 16px !important;
    font-weight: 700 !important;
    font-size: 10px !important;

}

.remove-btn.svelte-1s3ixll svg {
    fill: #fff !important;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-image: url('https://cdn.shopify.com/s/files/1/0034/7901/1441/files/image_103_f9b698fa-c23b-4a4f-8f44-74ca7882159f.png?v=1776762529');
}
.remove-btn.svelte-1s3ixll svg path{
   opacity: 0 !important;
}
    .product-tile-wrapper.false.svelte-1s3ixll {
    position: relative !important;
}
.remove-btn.svelte-1s3ixll {
    position: absolute !important;
    right: 15px !important;
    bottom: 6px !important;
}
.top-section  .img.svelte-1s3ixll img {
    height: auto !important;
}  
.top-section .img.svelte-1s3ixll {
    height: auto !important;
}     
 @media (max-width: 768px) {
      .item.svelte-1s3ixll .reduce-quantity.svelte-1s3ixll, .item.svelte-1s3ixll .increase-quantity.svelte-1s3ixll {
        min-width: unset !important;
    }
        .item.svelte-1s3ixll .variant-list.svelte-1s3ixll {
    margin-top: -1px !important;
}
}

   
@media (max-width: 446px) {
  .sidecart.svelte-1nlkjzs.svelte-1nlkjzs {
    width: 100% !important;
}
.sidecart .custom-brand-banner {
    font-size: 11px !important;
}
.item.svelte-1s3ixll .details .sidecart-product-title.svelte-1s3ixll {
    font-size: 14px !important;
}
.item.svelte-1s3ixll .item-price .final-price.svelte-1s3ixll, .item-price span.svelte-1s3ixll {
    font-size: 14px !important;
}
.my-checkout-text:after {
    height: 37px;
    width: 10px;
    right: -5px;
    background-size: cover;
    top: 0px;
}
.my-checkout-text:before {
    height: 37px;
    width: 10px;
    left: -5px;
    top: 0;
    background-size: cover;
}
.item-list-wrapper .item-price.svelte-1s3ixll {
    flex-wrap: wrap !important;
} 
.remove-btn.svelte-1s3ixll svg {
    width: 16px;
    height: 16px;
}     
.remove-btn.svelte-1s3ixll {
    bottom: 11px !important;
}      
}

     `;
        
        shadowRoot.appendChild(style);
        console.log("✅ CSS injected!");
    }
    
    injectCSS();
})();